import { render, staticRenderFns } from "./BarrasH.vue?vue&type=template&id=1aab01b2&"
import script from "./BarrasH.vue?vue&type=script&lang=js&"
export * from "./BarrasH.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports